@if (incomeTaxEntity$ | async) {
  @if(isPartner) {
    <snelstart-ui-alert type="success">
      Je gaat nu de jaarstukken voor <b>{{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.naam }}</b> invullen
      in de aangifte van <b>{{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.partnerAangifte?.aangever?.achternaam }}</b>
    </snelstart-ui-alert>
  } @else {
    <snelstart-ui-alert type="success">
      Je gaat nu de jaarstukken voor <b>{{ (incomeTaxEntity$ | async)?.aangifte?.box1?.winstUitOnderneming?.ondernemingen?.at(indexOnderneming)?.naam }}</b> invullen
      in de aangifte van <b>{{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.voorletters }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.tussenvoegsels || undefined }} {{ (incomeTaxEntity$ | async)?.aangifte?.aangever?.achternaam }}</b>
    </snelstart-ui-alert>
  }
}
